// import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
// import Edit from '@material-ui/icons/Edit';
// import Delete from '@material-ui/icons/Delete';
// import React, { useContext } from 'react';
// import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
// import { Row } from 'react-table';
// import ActionModal from '@components/Modal/ActionModal';
// import { useMutation } from '@apollo/client';
// import clientSimulator from 'utils/clientSimulator';
// import useNotifier from 'hooks/useNotifier';
// import {
//   DeleteItemFirmware,
//   DeleteItemFirmwareVariables,
// } from '../types/DeleteItemFirmware';
// import { deleteItemFirmwareMutation } from '../mutations';
// import { useNavigate } from 'react-router';
// import { itemFirmwareRoutes } from '../constants';
// import { ItemFirmwareContext } from '../context/FirmwareProvider';
// import HoverDropdown from '@components/CustomDropdown/HoverDropdown';
// interface IProps {
//   row: Row;
// }

// // @ts-ignore
// const useStyles = makeStyles(styles);

// const ItemFirmwareActions: React.FC<IProps> = ({ row, ...rest }) => {
//   const classes = useStyles();
//   const notify = useNotifier();
//   const history = useNavigate();
//   const { refetchItemFirmwares: refetch } = useContext(ItemFirmwareContext)
//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [deleteItem] = useMutation<
//     DeleteItemFirmware,
//     DeleteItemFirmwareVariables
//   >(deleteItemFirmwareMutation, {
//     client: clientSimulator,
//     onCompleted: (data) => {
//       notify({
//         status: 'success',
//         text: 'Item firmware deleted successfully',
//       });
//       refetch && refetch();
//       setIsModalOpen(false);
//     },
//   });
//   return (
//     <div className='actions-right' style={{ display: 'flex' }}>
//       <Tooltip
//         title='Delete'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Delete'
//           className={classes.tableActionButton}
//           onClick={() => setIsModalOpen(true)}
//         >
//           <Delete
//             className={classes.tableActionButtonIcon + ' ' + classes.delete}
//           />
//         </IconButton>
//       </Tooltip>
//       <Tooltip
//         id='expander'
//         onClick={() => {
//           history(itemFirmwareRoutes.getEditLink(row.values['node._id']));
//         }}
//         title='Edit'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Edit'
//           className={classes.tableActionButton}
//         >
//           <Edit
//             className={classes.tableActionButtonIcon + ' ' + classes.edit}
//           />
//         </IconButton>
//       </Tooltip>
//       <HoverDropdown
//         menus={[
//           {
//             name: "Upload FirmWare",
//             action: () => {
//             },
//           },
//         ]}
//       />
//       <ActionModal
//         isModalOpen={isModalOpen}
//         toggleModal={setIsModalOpen}
//         handleOnClickOkey={() =>
//           deleteItem({ variables: { itemFirmwareId: row.values['node._id'] } })
//         }
//         handleOnClickCancel={() => setIsModalOpen(false)}
//         okText='Delete'
//       >
//         <div>Are you sure you want to delete this item firmware?</div>
//       </ActionModal>
//     </div>
//   );
// };

// export default ItemFirmwareActions;


// import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
// import Edit from '@material-ui/icons/Edit';
// import Delete from '@material-ui/icons/Delete';
// import React, { useContext } from 'react';
// import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
// import { Row } from 'react-table';
// import ActionModal from '@components/Modal/ActionModal';
// import { useMutation } from '@apollo/client';
// import clientSimulator from 'utils/clientSimulator';
// import useNotifier from 'hooks/useNotifier';
// import {
//   DeleteItemFirmware,
//   DeleteItemFirmwareVariables,
// } from '../types/DeleteItemFirmware';
// import { deleteItemFirmwareMutation, generatePresignedUrlMutation } from '../mutations';
// import { useNavigate } from 'react-router';
// import { itemFirmwareRoutes } from '../constants';
// import { ItemFirmwareContext } from '../context/FirmwareProvider';
// import HoverDropdown from '@components/CustomDropdown/HoverDropdown';

// interface IProps {
//   row: Row;
// }

// // @ts-ignore
// const useStyles = makeStyles(styles);

// const ItemFirmwareActions: React.FC<IProps> = ({ row, ...rest }) => {
//   const classes = useStyles();
//   const notify = useNotifier();
//   const history = useNavigate();
//   const { refetchItemFirmwares: refetch } = useContext(ItemFirmwareContext);

//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [isUploadModalOpen, setIsUploadModalOpen] = React.useState(false);
//   const [selectedFile, setSelectedFile] = React.useState<File | null>(null);
//   const [version, setVersion] = React.useState('');
//   const [uploading, setUploading] = React.useState(false);
//   const [uploadProgress, setUploadProgress] = React.useState(0);

//   const [deleteItem] = useMutation<
//     DeleteItemFirmware,
//     DeleteItemFirmwareVariables
//   >(deleteItemFirmwareMutation, {
//     client: clientSimulator,
//     onCompleted: (data) => {
//       notify({
//         status: 'success',
//         text: 'Item firmware deleted successfully',
//       });
//       refetch && refetch();
//       setIsModalOpen(false);
//     },
//   });

//   const [generatePresignedUrl] = useMutation(generatePresignedUrlMutation, {
//     client: clientSimulator,
//     onCompleted: async (data) => {
//       if (selectedFile) {
//         await uploadToS3(data.generatePresignedUrl, selectedFile);
//       }
//     },
//     onError: (error) => {
//       notify({
//         status: 'error',
//         text: `Failed to generate upload URL: ${error.message}`,
//       });
//       setUploading(false);
//     },
//   });

//   const uploadToS3 = async (presignedUrl: string, file: File) => {
//     return new Promise<void>((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       xhr.upload.addEventListener('progress', (e) => {
//         if (e.lengthComputable) {
//           const percentComplete = (e.loaded / e.total) * 100;
//           setUploadProgress(Math.round(percentComplete));
//         }
//       });

//       xhr.addEventListener('load', () => {
//         if (xhr.status === 200) {
//           notify({
//             status: 'success',
//             text: 'Firmware uploaded successfully!',
//           });
//           refetch && refetch();
//           resetUploadModal();
//           resolve();
//         } else {
//           notify({
//             status: 'error',
//             text: `Upload failed with status ${xhr.status}`,
//           });
//           reject(new Error(`Upload failed with status ${xhr.status}`));
//         }
//         setUploading(false);
//       });

//       xhr.addEventListener('error', () => {
//         notify({
//           status: 'error',
//           text: 'Upload failed. Please try again.',
//         });
//         setUploading(false);
//         reject(new Error('Upload failed'));
//       });

//       xhr.open('PUT', presignedUrl);
//       xhr.setRequestHeader('Content-Type', file.type);
//       xhr.send(file);
//     });
//   };

//   const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (file) {
//       setSelectedFile(file);
//     }
//   };

//   const handleUpload = async () => {
//     if (!selectedFile || !version.trim()) {
//       notify({
//         status: 'error',
//         text: 'Please select a file and enter a version',
//       });
//       return;
//     }

//     setUploading(true);
//     setUploadProgress(0);

//     try {
//       const fileMetaData = {
//         version: version.trim(),
//         filename: selectedFile.name,
//         fileType: selectedFile.type || 'application/octet-stream',
//       };

//       await generatePresignedUrl({ variables: { fileMetaData } });
//     } catch (error) {
//       notify({
//         status: 'error',
//         text: 'Upload failed. Please try again.',
//       });
//       setUploading(false);
//     }
//   };

//   const resetUploadModal = () => {
//     setIsUploadModalOpen(false);
//     setSelectedFile(null);
//     setVersion('');
//     setUploading(false);
//     setUploadProgress(0);
//   };

//   const formatFileSize = (bytes: number): string => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   };

//   return (
//     <div className='actions-right' style={{ display: 'flex' }}>
//       <Tooltip
//         title='Delete'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Delete'
//           className={classes.tableActionButton}
//           onClick={() => setIsModalOpen(true)}
//         >
//           <Delete
//             className={classes.tableActionButtonIcon + ' ' + classes.delete}
//           />
//         </IconButton>
//       </Tooltip>
//       <Tooltip
//         id='expander'
//         onClick={() => {
//           history(itemFirmwareRoutes.getEditLink(row.values['node._id']));
//         }}
//         title='Edit'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Edit'
//           className={classes.tableActionButton}
//         >
//           <Edit
//             className={classes.tableActionButtonIcon + ' ' + classes.edit}
//           />
//         </IconButton>
//       </Tooltip>
//       <HoverDropdown
//         menus={[
//           {
//             name: "Upload FirmWare",
//             action: () => {
//               setIsUploadModalOpen(true);
//             },
//           },
//         ]}
//       />

//       {/* Delete Modal */}
//       <ActionModal
//         isModalOpen={isModalOpen}
//         toggleModal={setIsModalOpen}
//         handleOnClickOkey={() =>
//           deleteItem({ variables: { itemFirmwareId: row.values['node._id'] } })
//         }
//         handleOnClickCancel={() => setIsModalOpen(false)}
//         okText='Delete'
//       >
//         <div>Are you sure you want to delete this item firmware?</div>
//       </ActionModal>

//       {/* Upload Modal */}
//       <ActionModal
//         isModalOpen={isUploadModalOpen}
//         toggleModal={setIsUploadModalOpen}
//         handleOnClickOkey={handleUpload}
//         handleOnClickCancel={resetUploadModal}
//         okText={uploading ? 'Uploading...' : 'Upload'}
//         // okDisabled={!selectedFile || !version.trim() || uploading}
//       >
//         <div>
//           <h3 style={{ marginBottom: '16px' }}>Upload Firmware</h3>

//           <div style={{ marginBottom: '16px' }}>
//             <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
//               Firmware Version *
//             </label>
//             <input
//               type="text"
//               value={version}
//               onChange={(e) => setVersion(e.target.value)}
//               placeholder="e.g., v1.2.3"
//               style={{
//                 width: '100%',
//                 padding: '8px 12px',
//                 border: '1px solid #ccc',
//                 borderRadius: '4px',
//                 fontSize: '14px'
//               }}
//               disabled={uploading}
//             />
//           </div>

//           <div style={{ marginBottom: '16px' }}>
//             <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
//               Select File *
//             </label>
//             <input
//               type="file"
//               onChange={handleFileSelect}
//               style={{
//                 width: '100%',
//                 padding: '8px 12px',
//                 border: '1px solid #ccc',
//                 borderRadius: '4px',
//                 fontSize: '14px'
//               }}
//               disabled={uploading}
//             />
//           </div>

//           {selectedFile && (
//             <div style={{ 
//               marginBottom: '16px', 
//               padding: '12px', 
//               backgroundColor: '#f5f5f5', 
//               borderRadius: '4px' 
//             }}>
//               <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
//                 {selectedFile.name}
//               </div>
//               <div style={{ fontSize: '12px', color: '#666' }}>
//                 {formatFileSize(selectedFile.size)} • {selectedFile.type || 'Unknown type'}
//               </div>
//             </div>
//           )}

//           {uploading && (
//             <div style={{ marginBottom: '16px' }}>
//               <div style={{ 
//                 display: 'flex', 
//                 justifyContent: 'space-between', 
//                 marginBottom: '8px' 
//               }}>
//                 <span style={{ fontSize: '14px' }}>Uploading...</span>
//                 <span style={{ fontSize: '14px' }}>{uploadProgress}%</span>
//               </div>
//               <div style={{ 
//                 width: '100%', 
//                 backgroundColor: '#e0e0e0', 
//                 borderRadius: '4px',
//                 height: '8px' 
//               }}>
//                 <div 
//                   style={{ 
//                     width: `${uploadProgress}%`, 
//                     backgroundColor: '#4caf50', 
//                     height: '8px',
//                     borderRadius: '4px',
//                     transition: 'width 0.3s ease'
//                   }}
//                 />
//               </div>
//             </div>
//           )}
//         </div>
//       </ActionModal>
//     </div>
//   );
// };

// export default ItemFirmwareActions;


// import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
// import Edit from '@material-ui/icons/Edit';
// import Delete from '@material-ui/icons/Delete';
// import CloudUpload from '@material-ui/icons/CloudUpload';
// import React, { useContext } from 'react';
// import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
// import { Row } from 'react-table';
// import ActionModal from '@components/Modal/ActionModal';
// import DrawerSidebar from '@components/Drawer/DrawerSidebar';
// import GridContainer from '@components/Grid/GridContainer';
// import GridItem from '@components/Grid/GridItem';
// import Button from '@components/CustomButtons/Button';
// import { useMutation } from '@apollo/client';
// import clientSimulator from 'utils/clientSimulator';
// import useNotifier from 'hooks/useNotifier';
// import {
//   DeleteItemFirmware,
//   DeleteItemFirmwareVariables,
// } from '../types/DeleteItemFirmware';
// import { deleteItemFirmwareMutation, generatePresignedUrlMutation } from '../mutations';
// import { useNavigate } from 'react-router';
// import { itemFirmwareRoutes } from '../constants';
// import { ItemFirmwareContext } from '../context/FirmwareProvider';
// import HoverDropdown from '@components/CustomDropdown/HoverDropdown';

// interface IProps {
//   row: Row;
// }

// // @ts-ignore
// const useStyles = makeStyles(styles);

// const ItemFirmwareActions: React.FC<IProps> = ({ row, ...rest }) => {
//   const classes = useStyles();
//   const notify = useNotifier();
//   const history = useNavigate();
//   const { refetchItemFirmwares: refetch } = useContext(ItemFirmwareContext);

//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [isUploadModalOpen, setIsUploadModalOpen] = React.useState(false);
//   const [selectedFile, setSelectedFile] = React.useState<File | null>(null);
//   const [version, setVersion] = React.useState('');
//   const [uploading, setUploading] = React.useState(false);
//   const [uploadProgress, setUploadProgress] = React.useState(0);

//   const [deleteItem] = useMutation<
//     DeleteItemFirmware,
//     DeleteItemFirmwareVariables
//   >(deleteItemFirmwareMutation, {
//     client: clientSimulator,
//     onCompleted: (data) => {
//       notify({
//         status: 'success',
//         text: 'Item firmware deleted successfully',
//       });
//       refetch && refetch();
//       setIsModalOpen(false);
//     },
//   });

//   const [generatePresignedUrl] = useMutation(generatePresignedUrlMutation, {
//     client: clientSimulator,
//     onCompleted: async (data) => {
//       if (selectedFile) {
//         await uploadToS3(data.generatePresignedUrl, selectedFile);
//       }
//     },
//     onError: (error) => {
//       notify({
//         status: 'error',
//         text: `Failed to generate upload URL: ${error.message}`,
//       });
//       setUploading(false);
//     },
//   });

//   const uploadToS3 = async (presignedUrl: string, file: File) => {
//     return new Promise<void>((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       xhr.upload.addEventListener('progress', (e) => {
//         if (e.lengthComputable) {
//           const percentComplete = (e.loaded / e.total) * 100;
//           setUploadProgress(Math.round(percentComplete));
//         }
//       });

//       xhr.addEventListener('load', () => {
//         if (xhr.status === 200) {
//           notify({
//             status: 'success',
//             text: 'Firmware uploaded successfully!',
//           });
//           refetch && refetch();
//           resetUploadModal();
//           resolve();
//         } else {
//           notify({
//             status: 'error',
//             text: `Upload failed with status ${xhr.status}`,
//           });
//           reject(new Error(`Upload failed with status ${xhr.status}`));
//         }
//         setUploading(false);
//       });

//       xhr.addEventListener('error', () => {
//         notify({
//           status: 'error',
//           text: 'Upload failed. Please try again.',
//         });
//         setUploading(false);
//         reject(new Error('Upload failed'));
//       });

//       xhr.open('PUT', presignedUrl);
//       xhr.setRequestHeader('Content-Type', file.type);
//       xhr.send(file);
//     });
//   };

//   const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (file) {
//       setSelectedFile(file);
//     }
//   };

//   const handleUpload = async () => {
//     if (!selectedFile || !version.trim()) {
//       notify({
//         status: 'error',
//         text: 'Please select a file and enter a version',
//       });
//       return;
//     }

//     setUploading(true);
//     setUploadProgress(0);

//     try {
//       const fileMetaData = {
//         version: version.trim(),
//         filename: selectedFile.name,
//         fileType: selectedFile.type || 'application/octet-stream',
//       };

//       await generatePresignedUrl({ variables: { fileMetaData } });
//     } catch (error) {
//       notify({
//         status: 'error',
//         text: 'Upload failed. Please try again.',
//       });
//       setUploading(false);
//     }
//   };

//   const resetUploadModal = () => {
//     setIsUploadModalOpen(false);
//     setSelectedFile(null);
//     setVersion('');
//     setUploading(false);
//     setUploadProgress(0);
//   };

//   const formatFileSize = (bytes: number): string => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   };

//   return (
//     <div className='actions-right' style={{ display: 'flex' }}>
//       <Tooltip
//         title='Delete'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Delete'
//           className={classes.tableActionButton}
//           onClick={() => setIsModalOpen(true)}
//         >
//           <Delete
//             className={classes.tableActionButtonIcon + ' ' + classes.delete}
//           />
//         </IconButton>
//       </Tooltip>
//       <Tooltip
//         id='expander'
//         onClick={() => {
//           history(itemFirmwareRoutes.getEditLink(row.values['node._id']));
//         }}
//         title='Edit'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Edit'
//           className={classes.tableActionButton}
//         >
//           <Edit
//             className={classes.tableActionButtonIcon + ' ' + classes.edit}
//           />
//         </IconButton>
//       </Tooltip>
//       <HoverDropdown
//         menus={[
//           {
//             name: "Upload FirmWare",
//             action: () => {
//               setIsUploadModalOpen(true);
//             },
//           },
//         ]}
//       />

//       {/* Delete Modal */}
//       <ActionModal
//         isModalOpen={isModalOpen}
//         toggleModal={setIsModalOpen}
//         handleOnClickOkey={() =>
//           deleteItem({ variables: { itemFirmwareId: row.values['node._id'] } })
//         }
//         handleOnClickCancel={() => setIsModalOpen(false)}
//         okText='Delete'
//       >
//         <div>Are you sure you want to delete this item firmware?</div>
//       </ActionModal>

//       {/* Upload DrawerSidebar */}
//       {isUploadModalOpen && (
//         <DrawerSidebar
//           isModalOpen={isUploadModalOpen}
//           toggleModal={setIsUploadModalOpen}
//           title="Upload Firmware"
//           styles={{ maxWidth: "30vw", minWidth: "400px" }}
//         >
//           <GridContainer>
//             <GridItem xs={12}>
//               <div style={{ marginBottom: '20px' }}>
//                 <label style={{ 
//                   display: 'block', 
//                   marginBottom: '8px', 
//                   fontWeight: 'bold',
//                   fontSize: '14px'
//                 }}>
//                   Firmware Version *
//                 </label>
//                 <input
//                   type="text"
//                   value={version}
//                   onChange={(e) => setVersion(e.target.value)}
//                   placeholder="e.g., v1.2.3"
//                   style={{
//                     width: '100%',
//                     padding: '12px 16px',
//                     border: '1px solid #d1d5db',
//                     borderRadius: '6px',
//                     fontSize: '14px',
//                     fontFamily: 'inherit',
//                     transition: 'border-color 0.2s',
//                     outline: 'none'
//                   }}
//                   disabled={uploading}
//                   onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
//                   onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//                 />
//               </div>
//             </GridItem>

//             <GridItem xs={12}>
//               <div style={{ marginBottom: '20px' }}>
//                 <label style={{ 
//                   display: 'block', 
//                   marginBottom: '8px', 
//                   fontWeight: 'bold',
//                   fontSize: '14px'
//                 }}>
//                   Select File *
//                 </label>
//                 <input
//                   type="file"
//                   onChange={handleFileSelect}
//                   style={{
//                     width: '100%',
//                     padding: '12px 16px',
//                     border: '1px solid #d1d5db',
//                     borderRadius: '6px',
//                     fontSize: '14px',
//                     fontFamily: 'inherit',
//                     backgroundColor: '#f9fafb'
//                   }}
//                   disabled={uploading}
//                 />
//               </div>
//             </GridItem>

//             {selectedFile && (
//               <GridItem xs={12}>
//                 <div style={{ 
//                   marginBottom: '20px', 
//                   padding: '16px', 
//                   backgroundColor: '#f1f5f9', 
//                   borderRadius: '8px',
//                   border: '1px solid #e2e8f0'
//                 }}>
//                   <div style={{ 
//                     display: 'flex', 
//                     alignItems: 'center', 
//                     marginBottom: '8px' 
//                   }}>
//                     <CloudUpload style={{ 
//                       marginRight: '8px', 
//                       color: '#64748b', 
//                       fontSize: '18px' 
//                     }} />
//                     <div>
//                       <div style={{ 
//                         fontWeight: 'bold', 
//                         fontSize: '14px',
//                         color: '#1e293b'
//                       }}>
//                         {selectedFile.name}
//                       </div>
//                       <div style={{ 
//                         fontSize: '12px', 
//                         color: '#64748b',
//                         marginTop: '2px'
//                       }}>
//                         {formatFileSize(selectedFile.size)} • {selectedFile.type || 'Unknown type'}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </GridItem>
//             )}

//             {uploading && (
//               <GridItem xs={12}>
//                 <div style={{ marginBottom: '20px' }}>
//                   <div style={{ 
//                     display: 'flex', 
//                     justifyContent: 'space-between', 
//                     marginBottom: '8px' 
//                   }}>
//                     <span style={{ fontSize: '14px', fontWeight: '500' }}>
//                       Uploading...
//                     </span>
//                     <span style={{ fontSize: '14px', color: '#64748b' }}>
//                       {uploadProgress}%
//                     </span>
//                   </div>
//                   <div style={{ 
//                     width: '100%', 
//                     backgroundColor: '#e2e8f0', 
//                     borderRadius: '6px',
//                     height: '8px',
//                     overflow: 'hidden'
//                   }}>
//                     <div 
//                       style={{ 
//                         width: `${uploadProgress}%`, 
//                         backgroundColor: '#3b82f6', 
//                         height: '100%',
//                         borderRadius: '6px',
//                         transition: 'width 0.3s ease'
//                       }}
//                     />
//                   </div>
//                 </div>
//               </GridItem>
//             )}

//             <GridItem xs={12}>
//               <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
//                 <Button
//                   color="transparent"
//                   onClick={resetUploadModal}
//                   disabled={uploading}
//                   style={{ 
//                     marginRight: '8px',
//                     color: '#64748b',
//                     border: '1px solid #d1d5db'
//                   }}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   color="primary"
//                   onClick={handleUpload}
//                   disabled={!selectedFile || !version.trim() || uploading}
//                   style={{ 
//                     minWidth: '120px',
//                     opacity: (!selectedFile || !version.trim() || uploading) ? 0.6 : 1
//                   }}
//                 >
//                   {uploading ? 'Uploading...' : 'Upload'}
//                 </Button>
//               </div>
//             </GridItem>
//           </GridContainer>
//         </DrawerSidebar>
//       )}
//     </div>
//   );
// };

// export default ItemFirmwareActions;


// import { IconButton, makeStyles, Tooltip, TextField, Grid } from '@material-ui/core';
// import Edit from '@material-ui/icons/Edit';
// import Delete from '@material-ui/icons/Delete';
// import CloudUpload from '@material-ui/icons/CloudUpload';
// import React, { useContext, useState, useCallback } from 'react';
// import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
// import { Row } from 'react-table';
// import ActionModal from '@components/Modal/ActionModal';
// import { useMutation } from '@apollo/client';
// import clientSimulator from 'utils/clientSimulator';
// import useNotifier from 'hooks/useNotifier';
// import {
//   DeleteItemFirmware,
//   DeleteItemFirmwareVariables,
// } from '../types/DeleteItemFirmware';
// import { deleteItemFirmwareMutation, generatePresignedUrlMutation } from '../mutations';
// import { useNavigate } from 'react-router';
// import { itemFirmwareRoutes } from '../constants';
// import { ItemFirmwareContext } from '../context/FirmwareProvider';
// import HoverDropdown from '@components/CustomDropdown/HoverDropdown';
// import DrawerSidebar from '@components/Drawer/DrawerSidebar';
// import GridContainer from '@components/Grid/GridContainer';
// import GridItem from '@components/Grid/GridItem';
// import Button from '@components/CustomButtons/Button';
// import { Formik } from 'formik';

// interface IProps {
//   row: Row;
// }

// // @ts-ignore
// const useStyles = makeStyles(styles);

// const ItemFirmwareActions: React.FC<IProps> = ({ row, ...rest }) => {
//   const classes = useStyles();
//   const notify = useNotifier();
//   const history = useNavigate();
//   const { refetchItemFirmwares: refetch } = useContext(ItemFirmwareContext);

//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [uploadModalOpen, setUploadModalOpen] = useState(false);
//   const [file, setFile] = useState<File | null>(null);
//   const [version, setVersion] = useState('');
//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteItem] = useMutation<
//     DeleteItemFirmware,
//     DeleteItemFirmwareVariables
//   >(deleteItemFirmwareMutation, {
//     client: clientSimulator,
//     onCompleted: (data) => {
//       notify({
//         status: 'success',
//         text: 'Item firmware deleted successfully',
//       });
//       refetch && refetch();
//       setIsModalOpen(false);
//     },
//   });

//   const [generatePresignedUrl] = useMutation(generatePresignedUrlMutation, {
//     client: clientSimulator,
//     onError: (error) => {
//       notify({
//         status: 'error',
//         text: error.message || 'Failed to generate upload URL',
//       });
//       setUploading(false);
//     },
//   });

//   const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
//     const selectedFile = e.target.files?.[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//     }
//   }, []);

//   const uploadToS3 = useCallback(async (presignedUrl: string, file: File): Promise<void> => {
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       xhr.upload.addEventListener('progress', (e) => {
//         if (e.lengthComputable) {
//           const percentComplete = (e.loaded / e.total) * 100;
//           setUploadProgress(Math.round(percentComplete));
//         }
//       });

//       xhr.addEventListener('load', () => {
//         if (xhr.status === 200) {
//           resolve();
//         } else {
//           reject(new Error(`Upload failed with status ${xhr.status}`));
//         }
//       });

//       xhr.addEventListener('error', () => {
//         reject(new Error('Upload failed'));
//       });

//       xhr.open('PUT', presignedUrl);
//       xhr.setRequestHeader('Content-Type', file.type);
//       xhr.send(file);
//     });
//   }, []);

//   const handleUpload = useCallback(async () => {
//     if (!file || !version.trim()) {
//       notify({
//         status: 'error',
//         text: 'Please select a file and enter a version',
//       });
//       return;
//     }

//     setUploading(true);
//     setUploadProgress(0);

//     try {
//       // Step 1: Get presigned URL
//       const fileMetadata = {
//         version: version.trim(),
//         filename: file.name,
//         fileType: file.type || 'application/octet-stream'
//       };

//       const result = await generatePresignedUrl({
//         variables: { fileMetaData: fileMetadata }
//       });

//       const presignedUrl = result.data?.generatePresignedUrl;

//       if (!presignedUrl) {
//         throw new Error('Failed to get upload URL');
//       }

//       // Step 2: Upload file to S3
//       await uploadToS3(presignedUrl, file);

//       notify({
//         status: 'success',
//         text: 'Firmware uploaded successfully!',
//       });

//       // Reset form and close modal
//       setFile(null);
//       setVersion('');
//       setUploadProgress(0);
//       setUploadModalOpen(false);
//       refetch && refetch();

//     } catch (error: any) {
//       console.error('Upload error:', error);
//       notify({
//         status: 'error',
//         text: error.message || 'Upload failed. Please try again.',
//       });
//     } finally {
//       setUploading(false);
//     }
//   }, [file, version, generatePresignedUrl, uploadToS3, notify, refetch]);

//   const formatFileSize = useCallback((bytes: number): string => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   }, []);

//   return (
//     <div className='actions-right' style={{ display: 'flex' }}>
//       <Tooltip
//         title='Delete'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Delete'
//           className={classes.tableActionButton}
//           onClick={() => setIsModalOpen(true)}
//         >
//           <Delete
//             className={classes.tableActionButtonIcon + ' ' + classes.delete}
//           />
//         </IconButton>
//       </Tooltip>
//       <Tooltip
//         id='expander'
//         onClick={() => {
//           history(itemFirmwareRoutes.getEditLink(row.values['node._id']));
//         }}
//         title='Edit'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Edit'
//           className={classes.tableActionButton}
//         >
//           <Edit
//             className={classes.tableActionButtonIcon + ' ' + classes.edit}
//           />
//         </IconButton>
//       </Tooltip>

//       <HoverDropdown
//         menus={[
//           {
//             name: "Upload Firmware",
//             action: () => {
//               setUploadModalOpen(true);
//             },
//           },
//         ]}
//       />

//       {/* Upload Modal */}
//       <DrawerSidebar
//         isModalOpen={uploadModalOpen}
//         toggleModal={setUploadModalOpen}
//         title="Upload Firmware File"
//         styles={{ maxWidth: "30vw", minWidth: "400px" }}
//       >
//         <GridContainer>
//           <Formik onSubmit={(e) => {}} initialValues={{}}>
//             {(formBag) => (
//               <>
//                 <GridItem xs={12} sm={12} md={12}>
//                   <TextField
//                     label="Firmware Version"
//                     value={version}
//                     onChange={(e) => setVersion(e.target.value)}
//                     placeholder="e.g., v1.2.3"
//                     fullWidth
//                     variant="outlined"
//                     margin="normal"
//                     disabled={uploading}
//                     required
//                   />
//                 </GridItem>

//                 <GridItem xs={12} sm={12} md={12}>
//                   <input
//                     type="file"
//                     onChange={handleFileSelect}
//                     style={{
//                       width: '100%',
//                       padding: '10px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                       marginTop: '8px',
//                       marginBottom: '8px'
//                     }}
//                     disabled={uploading}
//                   />
//                 </GridItem>

//                 {file && (
//                   <GridItem xs={12} sm={12} md={12}>
//                     <div style={{
//                       padding: '12px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       marginBottom: '8px'
//                     }}>
//                       <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                         <CloudUpload style={{ marginRight: '8px', color: '#666' }} />
//                         <div style={{ flex: 1 }}>
//                           <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
//                             {file.name}
//                           </div>
//                           <div style={{ fontSize: '12px', color: '#666' }}>
//                             {formatFileSize(file.size)} • {file.type || 'Unknown type'}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </GridItem>
//                 )}

//                 {uploading && (
//                   <GridItem xs={12} sm={12} md={12}>
//                     <div style={{ marginBottom: '16px' }}>
//                       <div style={{ 
//                         display: 'flex', 
//                         justifyContent: 'space-between', 
//                         marginBottom: '4px',
//                         fontSize: '14px'
//                       }}>
//                         <span>Uploading...</span>
//                         <span>{uploadProgress}%</span>
//                       </div>
//                       <div style={{
//                         width: '100%',
//                         backgroundColor: '#e0e0e0',
//                         borderRadius: '4px',
//                         height: '8px'
//                       }}>
//                         <div 
//                           style={{
//                             backgroundColor: '#2196f3',
//                             height: '8px',
//                             borderRadius: '4px',
//                             transition: 'width 0.3s ease',
//                             width: `${uploadProgress}%`
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </GridItem>
//                 )}

//                 <GridItem sm={12}>
//                   <Button
//                     color="primary"
//                     onClick={handleUpload}
//                     style={{ marginLeft: 12 }}
//                     disabled={!file || !version.trim() || uploading}
//                   >
//                     {uploading ? "Uploading..." : "Upload Firmware"}
//                   </Button>
//                 </GridItem>
//               </>
//             )}
//           </Formik>
//         </GridContainer>
//       </DrawerSidebar>

//       <ActionModal
//         isModalOpen={isModalOpen}
//         toggleModal={setIsModalOpen}
//         handleOnClickOkey={() =>
//           deleteItem({ variables: { itemFirmwareId: row.values['node._id'] } })
//         }
//         handleOnClickCancel={() => setIsModalOpen(false)}
//         okText='Delete'
//       >
//         <div>Are you sure you want to delete this item firmware?</div>
//       </ActionModal>
//     </div>
//   );
// };

// export default ItemFirmwareActions;


// import { IconButton, makeStyles, Tooltip, TextField, Grid } from '@material-ui/core';
// import Edit from '@material-ui/icons/Edit';
// import Delete from '@material-ui/icons/Delete';
// import CloudUpload from '@material-ui/icons/CloudUpload';
// import React, { useContext, useState, useCallback } from 'react';
// import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
// import { Row } from 'react-table';
// import ActionModal from '@components/Modal/ActionModal';
// import { useMutation } from '@apollo/client';
// import clientSimulator from 'utils/clientSimulator';
// import useNotifier from 'hooks/useNotifier';
// import {
//   DeleteItemFirmware,
//   DeleteItemFirmwareVariables,
// } from '../types/DeleteItemFirmware';
// import { deleteItemFirmwareMutation, generatePresignedUrlMutation } from '../mutations';
// import { useNavigate } from 'react-router';
// import { itemFirmwareRoutes } from '../constants';
// import { ItemFirmwareContext } from '../context/FirmwareProvider';
// import HoverDropdown from '@components/CustomDropdown/HoverDropdown';
// import DrawerSidebar from '@components/Drawer/DrawerSidebar';
// import GridContainer from '@components/Grid/GridContainer';
// import GridItem from '@components/Grid/GridItem';
// import Button from '@components/CustomButtons/Button';
// import { Formik } from 'formik';

// interface IProps {
//   row: Row;
// }

// // @ts-ignore
// const useStyles = makeStyles(styles);

// const ItemFirmwareActions: React.FC<IProps> = ({ row, ...rest }) => {
//   const classes = useStyles();
//   const notify = useNotifier();
//   const history = useNavigate();
//   const { refetchItemFirmwares: refetch } = useContext(ItemFirmwareContext);

//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [uploadModalOpen, setUploadModalOpen] = useState(false);
//   const [file, setFile] = useState<File | null>(null);
//   const [version, setVersion] = useState('');
//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteItem] = useMutation<
//     DeleteItemFirmware,
//     DeleteItemFirmwareVariables
//   >(deleteItemFirmwareMutation, {
//     client: clientSimulator,
//     onCompleted: (data) => {
//       notify({
//         status: 'success',
//         text: 'Item firmware deleted successfully',
//       });
//       refetch && refetch();
//       setIsModalOpen(false);
//     },
//   });

//   const [generatePresignedUrl] = useMutation(generatePresignedUrlMutation, {
//     client: clientSimulator,
//     onError: (error) => {
//       notify({
//         status: 'error',
//         text: error.message || 'Failed to generate upload URL',
//       });
//       setUploading(false);
//     },
//   });

//   const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
//     const selectedFile = e.target.files?.[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//     }
//   }, []);

//   const uploadToS3 = useCallback(async (presignedUrl: string, file: File): Promise<void> => {
//     console.log("---1289----dasdas")
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       xhr.upload.addEventListener('progress', (e) => {
//         if (e.lengthComputable) {
//           const percentComplete = (e.loaded / e.total) * 100;
//           setUploadProgress(Math.round(percentComplete));
//         }
//       });

//       xhr.addEventListener('load', () => {
//         if (xhr.status === 200) {
//           resolve();
//         } else {
//           reject(new Error(`Upload failed with status ${xhr.status}`));
//         }
//       });

//       xhr.addEventListener('error', () => {
//         reject(new Error('Upload failed'));
//       });

//       xhr.open('PUT', presignedUrl);
//       xhr.setRequestHeader('Content-Type', file.type);
//       xhr.send(file);
//     });
//   }, []);

//   const handleUpload = useCallback(async () => {
//     if (!file || !version.trim()) {
//       notify({
//         status: 'error',
//         text: 'Please select a file and enter a version',
//       });
//       return;
//     }

//     setUploading(true);
//     setUploadProgress(0);

//     try {
//       // Step 1: Get presigned URL
//       const fileMetadata = {
//         version: version.trim(),
//         filename: file.name,
//         fileType: file.type || 'application/octet-stream'
//       };

//       const result = await generatePresignedUrl({
//         variables: { fileMetaData: fileMetadata }
//       });

//       const presignedUrl = result.data?.generatePresignedUrl;

//       if (!presignedUrl) {
//         throw new Error('Failed to get upload URL');
//       }

//       // Step 2: Upload file to S3
//       await uploadToS3(presignedUrl, file);

//       notify({
//         status: 'success',
//         text: 'Firmware uploaded successfully!',
//       });

//       // Reset form and close modal
//       setFile(null);
//       setVersion('');
//       setUploadProgress(0);
//       setUploadModalOpen(false);
//       refetch && refetch();

//     } catch (error: any) {
//       console.error('Upload error:', error);
//       notify({
//         status: 'error',
//         text: error.message || 'Upload failed. Please try again.',
//       });
//     } finally {
//       setUploading(false);
//     }
//   }, [file, version, generatePresignedUrl, uploadToS3, notify, refetch]);

//   const formatFileSize = useCallback((bytes: number): string => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   }, []);

//   return (
//     <div className='actions-right' style={{ display: 'flex' }}>
//       <Tooltip
//         title='Delete'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Delete'
//           className={classes.tableActionButton}
//           onClick={() => setIsModalOpen(true)}
//         >
//           <Delete
//             className={classes.tableActionButtonIcon + ' ' + classes.delete}
//           />
//         </IconButton>
//       </Tooltip>
//       <Tooltip
//         id='expander'
//         onClick={() => {
//           history(itemFirmwareRoutes.getEditLink(row.values['node._id']));
//         }}
//         title='Edit'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Edit'
//           className={classes.tableActionButton}
//         >
//           <Edit
//             className={classes.tableActionButtonIcon + ' ' + classes.edit}
//           />
//         </IconButton>
//       </Tooltip>

//       <HoverDropdown
//         menus={[
//           {
//             name: "Upload Firmware",
//             action: () => {
//               setVersion(row.values['node.version'] || '');
//               setUploadModalOpen(true);
//             },
//           },

//           {
//             name: "Download Firmware",
//             action: () => {
//             },
//           },
//         ]}
//       />

//       {/* Upload Modal */}
//       <DrawerSidebar
//         isModalOpen={uploadModalOpen}
//         toggleModal={setUploadModalOpen}
//         title="Upload Firmware File"
//         styles={{ maxWidth: "30vw", minWidth: "400px" }}
//       >
//         <GridContainer>
//           <Formik onSubmit={(e) => { }} initialValues={{}}>
//             {(formBag) => (
//               <>
//                 <GridItem xs={12} sm={12} md={12}>
//                   <TextField
//                     label="Firmware Version"
//                     value={version}
//                     onChange={(e) => setVersion(e.target.value)}
//                     placeholder="e.g., v1.2.3"
//                     fullWidth
//                     variant="outlined"
//                     margin="normal"
//                     disabled={true}
//                     required
//                   />
//                 </GridItem>

//                 <GridItem xs={12} sm={12} md={12}>
//                   <input
//                     type="file"
//                     onChange={handleFileSelect}
//                     style={{
//                       width: '100%',
//                       padding: '10px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                       marginTop: '8px',
//                       marginBottom: '8px'
//                     }}
//                     disabled={uploading}
//                   />
//                 </GridItem>

//                 {file && (
//                   <GridItem xs={12} sm={12} md={12}>
//                     <div style={{
//                       padding: '12px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       marginBottom: '8px'
//                     }}>
//                       <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                         <CloudUpload style={{ marginRight: '8px', color: '#666' }} />
//                         <div style={{ flex: 1 }}>
//                           <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
//                             {file.name}
//                           </div>
//                           <div style={{ fontSize: '12px', color: '#666' }}>
//                             {formatFileSize(file.size)} • {file.type || 'Unknown type'}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </GridItem>
//                 )}

//                 {uploading && (
//                   <GridItem xs={12} sm={12} md={12}>
//                     <div style={{ marginBottom: '16px' }}>
//                       <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         marginBottom: '4px',
//                         fontSize: '14px'
//                       }}>
//                         <span>Uploading...</span>
//                         <span>{uploadProgress}%</span>
//                       </div>
//                       <div style={{
//                         width: '100%',
//                         backgroundColor: '#e0e0e0',
//                         borderRadius: '4px',
//                         height: '8px'
//                       }}>
//                         <div
//                           style={{
//                             backgroundColor: '#2196f3',
//                             height: '8px',
//                             borderRadius: '4px',
//                             transition: 'width 0.3s ease',
//                             width: `${uploadProgress}%`
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </GridItem>
//                 )}

//                 <GridItem sm={12}>
//                   <Button
//                     color="primary"
//                     onClick={handleUpload}
//                     style={{ marginLeft: 12 }}
//                     disabled={!file || !version.trim() || uploading}
//                   >
//                     {uploading ? "Uploading..." : "Upload Firmware"}
//                   </Button>
//                 </GridItem>
//               </>
//             )}
//           </Formik>
//         </GridContainer>
//       </DrawerSidebar>

//       <ActionModal
//         isModalOpen={isModalOpen}
//         toggleModal={setIsModalOpen}
//         handleOnClickOkey={() =>
//           deleteItem({ variables: { itemFirmwareId: row.values['node._id'] } })
//         }
//         handleOnClickCancel={() => setIsModalOpen(false)}
//         okText='Delete'
//       >
//         <div>Are you sure you want to delete this item firmware?</div>
//       </ActionModal>
//     </div>
//   );
// };

// export default ItemFirmwareActions;

// import { IconButton, makeStyles, Tooltip, TextField, Grid } from '@material-ui/core';
// import Edit from '@material-ui/icons/Edit';
// import Delete from '@material-ui/icons/Delete';
// import CloudUpload from '@material-ui/icons/CloudUpload';
// import GetApp from '@material-ui/icons/GetApp';
// import React, { useContext, useState, useCallback } from 'react';
// import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
// import { Row } from 'react-table';
// import ActionModal from '@components/Modal/ActionModal';
// import { useMutation, useLazyQuery } from '@apollo/client';
// import clientSimulator from 'utils/clientSimulator';
// import useNotifier from 'hooks/useNotifier';
// import {
//   DeleteItemFirmware,
//   DeleteItemFirmwareVariables,
// } from '../types/DeleteItemFirmware';
// import { deleteItemFirmwareMutation, generatePresignedUrlMutation } from '../mutations';
// import { useNavigate } from 'react-router';
// import { itemFirmwareRoutes } from '../constants';
// import { ItemFirmwareContext } from '../context/FirmwareProvider';
// import HoverDropdown from '@components/CustomDropdown/HoverDropdown';
// import DrawerSidebar from '@components/Drawer/DrawerSidebar';
// import GridContainer from '@components/Grid/GridContainer';
// import GridItem from '@components/Grid/GridItem';
// import Button from '@components/CustomButtons/Button';
// import { Formik } from 'formik';
// import { gql } from '@apollo/client';

// // GraphQL query for getting firmware download URLs
// const GET_FIRMWARE_DOWNLOAD_URL = gql`
//   query GetFileObjectsForFirmwareVersion($version: String!) {
//     getFileObjectsForFirmwareVersion(version: $version) {
//       filename
//       size
//       lastModified
//       downloadUrl
//     }
//   }
// `;

// interface IProps {
//   row: Row;
// }

// interface FirmwareFile {
//   filename: string;
//   size: number;
//   lastModified: string;
//   downloadUrl: string;
// }

// // @ts-ignore
// const useStyles = makeStyles(styles);

// const ItemFirmwareActions: React.FC<IProps> = ({ row, ...rest }) => {
//   const classes = useStyles();
//   const notify = useNotifier();
//   const history = useNavigate();
//   const { refetchItemFirmwares: refetch } = useContext(ItemFirmwareContext);

//   const [isModalOpen, setIsModalOpen] = React.useState(false);
//   const [uploadModalOpen, setUploadModalOpen] = useState(false);
//   const [file, setFile] = useState<File | null>(null);
//   const [version, setVersion] = useState('');
//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [downloading, setDownloading] = useState(false);

//   const [deleteItem] = useMutation<
//     DeleteItemFirmware,
//     DeleteItemFirmwareVariables
//   >(deleteItemFirmwareMutation, {
//     client: clientSimulator,
//     onCompleted: (data) => {
//       notify({
//         status: 'success',
//         text: 'Item firmware deleted successfully',
//       });
//       refetch && refetch();
//       setIsModalOpen(false);
//     },
//   });

//   const [generatePresignedUrl] = useMutation(generatePresignedUrlMutation, {
//     client: clientSimulator,
//     onError: (error) => {
//       notify({
//         status: 'error',
//         text: error.message || 'Failed to generate upload URL',
//       });
//       setUploading(false);
//     },
//   });

//   const [getFirmwareFiles] = useLazyQuery(GET_FIRMWARE_DOWNLOAD_URL, {
//     client: clientSimulator,
//     onCompleted: (data) => {
//       if (data?.getFileObjectsForFirmwareVersion && data.getFileObjectsForFirmwareVersion.length > 0) {
//         // Automatically download the first file (or you can modify logic for multiple files)
//         const firstFile = data.getFileObjectsForFirmwareVersion[0];
//         downloadFile(firstFile);
//       } else {
//         notify({
//           status: 'error',
//           text: 'No firmware files found for this version',
//         });
//         setDownloading(false);
//       }
//     },
//     onError: (error) => {
//       notify({
//         status: 'error',
//         text: error.message || 'Failed to fetch firmware files',
//       });
//       setDownloading(false);
//     },
//   });

//   const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
//     const selectedFile = e.target.files?.[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//     }
//   }, []);

//   const uploadToS3 = useCallback(async (presignedUrl: string, file: File): Promise<void> => {
//     console.log("Starting S3 upload");
//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       xhr.upload.addEventListener('progress', (e) => {
//         if (e.lengthComputable) {
//           const percentComplete = (e.loaded / e.total) * 100;
//           setUploadProgress(Math.round(percentComplete));
//         }
//       });

//       xhr.addEventListener('load', () => {
//         if (xhr.status === 200) {
//           resolve();
//         } else {
//           reject(new Error(`Upload failed with status ${xhr.status}`));
//         }
//       });

//       xhr.addEventListener('error', () => {
//         reject(new Error('Upload failed'));
//       });

//       xhr.open('PUT', presignedUrl);
//       xhr.setRequestHeader('Content-Type', file.type);
//       xhr.send(file);
//     });
//   }, []);

//   const handleUpload = useCallback(async () => {
//     if (!file || !version.trim()) {
//       notify({
//         status: 'error',
//         text: 'Please select a file and enter a version',
//       });
//       return;
//     }

//     setUploading(true);
//     setUploadProgress(0);

//     try {
//       // Step 1: Get presigned URL
//       const fileMetadata = {
//         version: version.trim(),
//         filename: file.name,
//         fileType: file.type || 'application/octet-stream'
//       };

//       const result = await generatePresignedUrl({
//         variables: { fileMetaData: fileMetadata }
//       });

//       const presignedUrl = result.data?.generatePresignedUrl;

//       if (!presignedUrl) {
//         throw new Error('Failed to get upload URL');
//       }

//       // Step 2: Upload file to S3
//       await uploadToS3(presignedUrl, file);

//       notify({
//         status: 'success',
//         text: 'Firmware uploaded successfully!',
//       });

//       // Reset form and close modal
//       setFile(null);
//       setVersion('');
//       setUploadProgress(0);
//       setUploadModalOpen(false);
//       refetch && refetch();

//     } catch (error: any) {
//       console.error('Upload error:', error);
//       notify({
//         status: 'error',
//         text: error.message || 'Upload failed. Please try again.',
//       });
//     } finally {
//       setUploading(false);
//     }
//   }, [file, version, generatePresignedUrl, uploadToS3, notify, refetch]);

//   // Download functionality
//   const handleDownloadFirmware = useCallback(() => {
//     const firmwareVersion = row.values['node.version'];
//     if (!firmwareVersion) {
//       notify({
//         status: 'error',
//         text: 'No firmware version found for this item',
//       });
//       return;
//     }

//     if (downloading) {
//       notify({
//         status: 'info',
//         text: 'Download already in progress...',
//       });
//       return;
//     }

//     setDownloading(true);
//     notify({
//       status: 'info',
//       text: 'Fetching firmware download link...',
//     });

//     // Fetch firmware files for this version
//     getFirmwareFiles({
//       variables: { version: firmwareVersion }
//     });
//   }, [row.values, getFirmwareFiles, notify, downloading]);

//   const downloadFile = useCallback(async (firmwareFile: FirmwareFile) => {
//     try {
//       notify({
//         status: 'info',
//         text: `Starting download of ${firmwareFile.filename}...`,
//       });

//       // Create a temporary anchor element to trigger download
//       const link = document.createElement('a');
//       link.href = firmwareFile.downloadUrl;
//       link.download = firmwareFile.filename;
//       link.target = '_blank';
      
//       // Append to body, click, and remove
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       notify({
//         status: 'success',
//         text: `${firmwareFile.filename} download started successfully!`,
//       });

//     } catch (error: any) {
//       console.error('Download error:', error);
//       notify({
//         status: 'error',
//         text: error.message || 'Download failed. Please try again.',
//       });
//     } finally {
//       setDownloading(false);
//     }
//   }, [notify]);

//   const formatFileSize = useCallback((bytes: number): string => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   }, []);

//   const formatDate = useCallback((dateString: string): string => {
//     try {
//       return new Date(dateString).toLocaleDateString();
//     } catch {
//       return dateString;
//     }
//   }, []);

//   return (
//     <div className='actions-right' style={{ display: 'flex' }}>
//       <Tooltip
//         title='Delete'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Delete'
//           className={classes.tableActionButton}
//           onClick={() => setIsModalOpen(true)}
//         >
//           <Delete
//             className={classes.tableActionButtonIcon + ' ' + classes.delete}
//           />
//         </IconButton>
//       </Tooltip>
//       <Tooltip
//         id='expander'
//         onClick={() => {
//           history(itemFirmwareRoutes.getEditLink(row.values['node._id']));
//         }}
//         title='Edit'
//         placement='top'
//         classes={{ tooltip: classes.tooltip }}
//       >
//         <IconButton
//           id='expander'
//           aria-label='Edit'
//           className={classes.tableActionButton}
//         >
//           <Edit
//             className={classes.tableActionButtonIcon + ' ' + classes.edit}
//           />
//         </IconButton>
//       </Tooltip>

//       <HoverDropdown
//         menus={[
//           {
//             name: "Upload Firmware",
//             action: () => {
//               setVersion(row.values['node.version'] || '');
//               setUploadModalOpen(true);
//             },
//           },
//           {
//             name: "Download Firmware",
//             action: handleDownloadFirmware,
//           },
//         ]}
//       />

//       {/* Upload Modal */}
//       <DrawerSidebar
//         isModalOpen={uploadModalOpen}
//         toggleModal={setUploadModalOpen}
//         title="Upload Firmware File"
//         styles={{ maxWidth: "30vw", minWidth: "400px" }}
//       >
//         <GridContainer>
//           <Formik onSubmit={(e) => { }} initialValues={{}}>
//             {(formBag) => (
//               <>
//                 <GridItem xs={12} sm={12} md={12}>
//                   <TextField
//                     label="Firmware Version"
//                     value={version}
//                     onChange={(e) => setVersion(e.target.value)}
//                     placeholder="e.g., v1.2.3"
//                     fullWidth
//                     variant="outlined"
//                     margin="normal"
//                     disabled={true}
//                     required
//                   />
//                 </GridItem>

//                 <GridItem xs={12} sm={12} md={12}>
//                   <input
//                     type="file"
//                     onChange={handleFileSelect}
//                     style={{
//                       width: '100%',
//                       padding: '10px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                       marginTop: '8px',
//                       marginBottom: '8px'
//                     }}
//                     disabled={uploading}
//                   />
//                 </GridItem>

//                 {file && (
//                   <GridItem xs={12} sm={12} md={12}>
//                     <div style={{
//                       padding: '12px',
//                       backgroundColor: '#f5f5f5',
//                       borderRadius: '4px',
//                       marginBottom: '8px'
//                     }}>
//                       <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
//                         <CloudUpload style={{ marginRight: '8px', color: '#666' }} />
//                         <div style={{ flex: 1 }}>
//                           <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
//                             {file.name}
//                           </div>
//                           <div style={{ fontSize: '12px', color: '#666' }}>
//                             {formatFileSize(file.size)} • {file.type || 'Unknown type'}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </GridItem>
//                 )}

//                 {uploading && (
//                   <GridItem xs={12} sm={12} md={12}>
//                     <div style={{ marginBottom: '16px' }}>
//                       <div style={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         marginBottom: '4px',
//                         fontSize: '14px'
//                       }}>
//                         <span>Uploading...</span>
//                         <span>{uploadProgress}%</span>
//                       </div>
//                       <div style={{
//                         width: '100%',
//                         backgroundColor: '#e0e0e0',
//                         borderRadius: '4px',
//                         height: '8px'
//                       }}>
//                         <div
//                           style={{
//                             backgroundColor: '#2196f3',
//                             height: '8px',
//                             borderRadius: '4px',
//                             transition: 'width 0.3s ease',
//                             width: `${uploadProgress}%`
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </GridItem>
//                 )}

//                 <GridItem sm={12}>
//                   <Button
//                     color="primary"
//                     onClick={handleUpload}
//                     style={{ marginLeft: 12 }}
//                     disabled={!file || !version.trim() || uploading}
//                   >
//                     {uploading ? "Uploading..." : "Upload Firmware"}
//                   </Button>
//                 </GridItem>
//               </>
//             )}
//           </Formik>
//         </GridContainer>
//       </DrawerSidebar>

//       {/* Delete Modal */}
//       <ActionModal
//         isModalOpen={isModalOpen}
//         toggleModal={setIsModalOpen}
//         handleOnClickOkey={() =>
//           deleteItem({ variables: { itemFirmwareId: row.values['node._id'] } })
//         }
//         handleOnClickCancel={() => setIsModalOpen(false)}
//         okText='Delete'
//       >
//         <div>Are you sure you want to delete this item firmware?</div>
//       </ActionModal>
//     </div>
//   );
// };

// export default ItemFirmwareActions;

import { IconButton, makeStyles, Tooltip, TextField, Grid } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import CloudUpload from '@material-ui/icons/CloudUpload';
import GetApp from '@material-ui/icons/GetApp';
import React, { useContext, useState, useCallback } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
import { Row } from 'react-table';
import ActionModal from '@components/Modal/ActionModal';
import { useMutation, useLazyQuery } from '@apollo/client';
import clientSimulator from 'utils/clientSimulator';
import useNotifier from 'hooks/useNotifier';
import {
  DeleteItemFirmware,
  DeleteItemFirmwareVariables,
} from '../types/DeleteItemFirmware';
import { deleteItemFirmwareMutation, generatePresignedUrlMutation } from '../mutations';
import { useNavigate } from 'react-router';
import { itemFirmwareRoutes } from '../constants';
import { ItemFirmwareContext } from '../context/FirmwareProvider';
import HoverDropdown from '@components/CustomDropdown/HoverDropdown';
import DrawerSidebar from '@components/Drawer/DrawerSidebar';
import GridContainer from '@components/Grid/GridContainer';
import GridItem from '@components/Grid/GridItem';
import Button from '@components/CustomButtons/Button';
import { Formik } from 'formik';
import { gql } from '@apollo/client';

// GraphQL query for getting firmware download URLs
const GET_FIRMWARE_DOWNLOAD_URL = gql`
  query GetFileObjectsForFirmwareVersion($version: String!) {
    getFileObjectsForFirmwareVersion(version: $version) {
      filename
      size
      lastModified
      downloadUrl
    }
  }
`;

interface IProps {
  row: Row;
}

interface FirmwareFile {
  filename: string;
  size: number;
  lastModified: string;
  downloadUrl: string;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const ItemFirmwareActions: React.FC<IProps> = ({ row, ...rest }) => {
  const classes = useStyles();
  const notify = useNotifier();
  const history = useNavigate();
  const { refetchItemFirmwares: refetch } = useContext(ItemFirmwareContext);

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [version, setVersion] = useState('');
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [downloading, setDownloading] = useState(false);

  const [deleteItem] = useMutation<
    DeleteItemFirmware,
    DeleteItemFirmwareVariables
  >(deleteItemFirmwareMutation, {
    client: clientSimulator,
    onCompleted: (data) => {
      notify({
        status: 'success',
        text: 'Item firmware deleted successfully',
      });
      refetch && refetch();
      setIsModalOpen(false);
    },
  });

  const [generatePresignedUrl] = useMutation(generatePresignedUrlMutation, {
    client: clientSimulator,
    onError: (error) => {
      notify({
        status: 'error',
        text: error.message || 'Failed to generate upload URL',
      });
      setUploading(false);
    },
  });

  const [getFirmwareFiles] = useLazyQuery(GET_FIRMWARE_DOWNLOAD_URL, {
    client: clientSimulator,
    onCompleted: (data) => {
      if (data?.getFileObjectsForFirmwareVersion && data.getFileObjectsForFirmwareVersion.length > 0) {
        // Automatically download the first file (or you can modify logic for multiple files)
        const firstFile = data.getFileObjectsForFirmwareVersion[0];
        downloadFile(firstFile);
      } else {
        notify({
          status: 'error',
          text: 'No firmware files found for this version',
        });
        setDownloading(false);
      }
    },
    onError: (error) => {
      notify({
        status: 'error',
        text: error.message || 'Failed to fetch firmware files',
      });
      setDownloading(false);
    },
  });

  const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  }, []);

  const uploadToS3 = useCallback(async (presignedUrl: string, file: File): Promise<void> => {
    console.log("Starting S3 upload");
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const percentComplete = (e.loaded / e.total) * 100;
          setUploadProgress(Math.round(percentComplete));
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status === 200) {
          resolve();
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      });

      xhr.addEventListener('error', () => {
        reject(new Error('Upload failed'));
      });

      xhr.open('PUT', presignedUrl);
      xhr.setRequestHeader('Content-Type', file.type);
      xhr.send(file);
    });
  }, []);

  const handleUpload = useCallback(async () => {
    if (!file || !version.trim()) {
      notify({
        status: 'error',
        text: 'Please select a file and enter a version',
      });
      return;
    }

    setUploading(true);
    setUploadProgress(0);

    try {
      // Step 1: Get presigned URL
      const fileMetadata = {
        version: version.trim(),
        filename: file.name,
        fileType: file.type || 'application/octet-stream'
      };

      const result = await generatePresignedUrl({
        variables: { fileMetaData: fileMetadata }
      });

      const presignedUrl = result.data?.generatePresignedUrl;

      if (!presignedUrl) {
        throw new Error('Failed to get upload URL');
      }

      // Step 2: Upload file to S3
      await uploadToS3(presignedUrl, file);

      notify({
        status: 'success',
        text: 'Firmware uploaded successfully!',
      });

      // Reset form and close modal
      setFile(null);
      setVersion('');
      setUploadProgress(0);
      setUploadModalOpen(false);
      refetch && refetch();

    } catch (error: any) {
      console.error('Upload error:', error);
      notify({
        status: 'error',
        text: error.message || 'Upload failed. Please try again.',
      });
    } finally {
      setUploading(false);
    }
  }, [file, version, generatePresignedUrl, uploadToS3, notify, refetch]);

  // Download functionality
  const handleDownloadFirmware = useCallback(() => {
    const firmwareVersion = row.values['node.version'];
    if (!firmwareVersion) {
      notify({
        status: 'error',
        text: 'No firmware version found for this item',
      });
      return;
    }

    if (downloading) {
      notify({
        status: 'info',
        text: 'Download already in progress...',
      });
      return;
    }

    setDownloading(true);
    notify({
      status: 'info',
      text: 'Fetching firmware download link...',
    });

    // Fetch firmware files for this version
    getFirmwareFiles({
      variables: { version: firmwareVersion }
    });
  }, [row.values, getFirmwareFiles, notify, downloading]);

  const downloadFile = useCallback(async (firmwareFile: FirmwareFile) => {
    try {
      notify({
        status: 'info',
        text: `Starting download of ${firmwareFile.filename}...`,
      });

      // Method 1: Try direct download first
      try {
        const link = document.createElement('a');
        link.href = firmwareFile.downloadUrl;
        link.download = firmwareFile.filename;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        
        // Add to body temporarily
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        notify({
          status: 'success',
          text: `${firmwareFile.filename} download started successfully!`,
        });
        return;
      } catch (directDownloadError) {
        console.warn('Direct download failed, trying fetch method:', directDownloadError);
      }

      // Method 2: If direct download fails, try fetch with blob
      try {
        const response = await fetch(firmwareFile.downloadUrl, {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit', // Don't send cookies
          headers: {
            // Minimal headers to avoid signing issues
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = firmwareFile.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the blob URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);

        notify({
          status: 'success',
          text: `${firmwareFile.filename} download completed successfully!`,
        });
      } catch (fetchError) {
        console.error('Fetch download failed:', fetchError);
        
        // Method 3: Fallback - open in new tab
        notify({
          status: 'info',
          text: 'Opening download in new tab...',
        });
        
        window.open(firmwareFile.downloadUrl, '_blank', 'noopener,noreferrer');
        
        notify({
          status: 'success',
          text: 'Download link opened in new tab. Please save the file.',
        });
      }

    } catch (error: any) {
      console.error('Download error:', error);
      
      let errorMessage = 'Download failed. Please try again.';
      
      if (error.message.includes('AccessDenied')) {
        errorMessage = 'Access denied. The download link may have expired or is not properly configured.';
      } else if (error.message.includes('CORS')) {
        errorMessage = 'CORS error. Opening download in new tab...';
        // Try opening in new tab as fallback
        window.open(firmwareFile.downloadUrl, '_blank', 'noopener,noreferrer');
        errorMessage = 'Download opened in new tab.';
      }
      
      notify({
        status: 'error',
        text: errorMessage,
      });
    } finally {
      setDownloading(false);
    }
  }, [notify]);

  const formatFileSize = useCallback((bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }, []);

  const formatDate = useCallback((dateString: string): string => {
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return dateString;
    }
  }, []);

  return (
    <div className='actions-right' style={{ display: 'flex' }}>
      <Tooltip
        title='Delete'
        placement='top'
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id='expander'
          aria-label='Delete'
          className={classes.tableActionButton}
          onClick={() => setIsModalOpen(true)}
        >
          <Delete
            className={classes.tableActionButtonIcon + ' ' + classes.delete}
          />
        </IconButton>
      </Tooltip>
      <Tooltip
        id='expander'
        onClick={() => {
          history(itemFirmwareRoutes.getEditLink(row.values['node._id']));
        }}
        title='Edit'
        placement='top'
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id='expander'
          aria-label='Edit'
          className={classes.tableActionButton}
        >
          <Edit
            className={classes.tableActionButtonIcon + ' ' + classes.edit}
          />
        </IconButton>
      </Tooltip>

      <HoverDropdown
        menus={[
          {
            name: "Upload Firmware",
            action: () => {
              setVersion(row.values['node.version'] || '');
              setUploadModalOpen(true);
            },
          },
          {
            name: "Download Firmware",
            action: handleDownloadFirmware,
          },
        ]}
      />

      {/* Upload Modal */}
      <DrawerSidebar
        isModalOpen={uploadModalOpen}
        toggleModal={setUploadModalOpen}
        title="Upload Firmware File"
        styles={{ maxWidth: "30vw", minWidth: "400px" }}
      >
        <GridContainer>
          <Formik onSubmit={(e) => { }} initialValues={{}}>
            {(formBag) => (
              <>
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    label="Firmware Version"
                    value={version}
                    onChange={(e) => setVersion(e.target.value)}
                    placeholder="e.g., v1.2.3"
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    disabled={true}
                    required
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <input
                    type="file"
                    onChange={handleFileSelect}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      marginTop: '8px',
                      marginBottom: '8px'
                    }}
                    disabled={uploading}
                  />
                </GridItem>

                {file && (
                  <GridItem xs={12} sm={12} md={12}>
                    <div style={{
                      padding: '12px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                      marginBottom: '8px'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                        <CloudUpload style={{ marginRight: '8px', color: '#666' }} />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {file.name}
                          </div>
                          <div style={{ fontSize: '12px', color: '#666' }}>
                            {formatFileSize(file.size)} • {file.type || 'Unknown type'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </GridItem>
                )}

                {uploading && (
                  <GridItem xs={12} sm={12} md={12}>
                    <div style={{ marginBottom: '16px' }}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '4px',
                        fontSize: '14px'
                      }}>
                        <span>Uploading...</span>
                        <span>{uploadProgress}%</span>
                      </div>
                      <div style={{
                        width: '100%',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '4px',
                        height: '8px'
                      }}>
                        <div
                          style={{
                            backgroundColor: '#2196f3',
                            height: '8px',
                            borderRadius: '4px',
                            transition: 'width 0.3s ease',
                            width: `${uploadProgress}%`
                          }}
                        />
                      </div>
                    </div>
                  </GridItem>
                )}

                <GridItem sm={12}>
                  <Button
                    color="primary"
                    onClick={handleUpload}
                    style={{ marginLeft: 12 }}
                    disabled={!file || !version.trim() || uploading}
                  >
                    {uploading ? "Uploading..." : "Upload Firmware"}
                  </Button>
                </GridItem>
              </>
            )}
          </Formik>
        </GridContainer>
      </DrawerSidebar>

      {/* Delete Modal */}
      <ActionModal
        isModalOpen={isModalOpen}
        toggleModal={setIsModalOpen}
        handleOnClickOkey={() =>
          deleteItem({ variables: { itemFirmwareId: row.values['node._id'] } })
        }
        handleOnClickCancel={() => setIsModalOpen(false)}
        okText='Delete'
      >
        <div>Are you sure you want to delete this item firmware?</div>
      </ActionModal>
    </div>
  );
};

export default ItemFirmwareActions;